// extracted by mini-css-extract-plugin
export default {"container":"QuoteSearch_container__2yika","pageTitle":"QuoteSearch_pageTitle__781hm","errorMessage":"QuoteSearch_errorMessage__2A01W","infoMessage":"QuoteSearch_infoMessage__o4P9O"};